import PostMeta from './PostMeta';
export default PostMeta;
